import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconEdit } from '../../../../../../assets/icons/icon-edit';
import { DialogTimePicker, InputMui } from '../../../../../../components';
import Info from '../../../../../../components/channel-configuration/info';
import { millisecondsToTime } from '../../../../../../utils/helpers';
import { ChannelGateType, ChannelType } from '../../../../types';

type SbsSignalTimeProps = {
  channel: ChannelType;
  handleSave: (time: string) => void;
};

const SbsSignalTime: React.FC<SbsSignalTimeProps> = ({ channel, handleSave }) => {
  const { t } = useTranslation('configuration');
  const [showTimePicker, setShowTimePicker] = useState<boolean>(false);
  const sbsSignalTimeInMs = millisecondsToTime((channel.data as ChannelGateType).sbsSignalTimeInMs || 0);

  return (
    <>
      <hr />
      <Info title={`${t('signalTime')} (s)`} />
      <InputMui
        value={sbsSignalTimeInMs}
        readOnly
        onClickInput={() => setShowTimePicker(true)}
        endIcon={<IconEdit />}
      />
      <DialogTimePicker
        header={`${t('signalTime')} (s)`}
        open={showTimePicker}
        setOpen={setShowTimePicker}
        onSave={(value) => handleSave(value)}
        time={sbsSignalTimeInMs}
        showSeconds
        disableHours
        disableMinutes
        minSeconds={1}
      />
    </>
  );
};

export default SbsSignalTime;
